import * as React from "react"
import { TabPanels, TabPanel } from "@chakra-ui/react"
import layoutStates from "../../../recoil/atoms/layout"
import { useSetRecoilState } from "recoil"
import { CHAT_DESKTOP_TAB_INDEX } from "../../../constants"

interface TabPanelsListProps {
  id: number | string
  tabPanel: React.ReactNode
  styles?: React.CSSProperties
}

interface ServicesTabPanelsProps {
  servicePanelBackgroundColor?: string
  sidebarOpen?: boolean
  tabPanelsList: readonly TabPanelsListProps[]
}

const _ServicesTabPanels: React.FC<ServicesTabPanelsProps> = ({
  servicePanelBackgroundColor,
  sidebarOpen,
  tabPanelsList
}) => {
  const setChatTab = useSetRecoilState(layoutStates.isChatTab)
  const startTabId = tabPanelsList?.length !== 0 ? tabPanelsList[0]?.id : -1

  React.useEffect(() => {
    // To set chatTab to true when there is chat tab is first
    if (startTabId !== -1) {
      if (startTabId === CHAT_DESKTOP_TAB_INDEX) {
        setChatTab(true)
      } else {
        setChatTab(false)
      }
    }
  }, [startTabId, setChatTab])

  return (
    <TabPanels
      className={`sidebar-content ${sidebarOpen ? "open" : "close"}`}
      bg={servicePanelBackgroundColor}
      overflowY="auto"
      display="flex"
      flexDirection="column"
    >
      {tabPanelsList.map(el => (
        <TabPanel key={el?.id} style={{ ...el?.styles }}>
          {el?.tabPanel}
        </TabPanel>
      ))}
    </TabPanels>
  )
}

export const ServicesTabPanels = React.memo(_ServicesTabPanels)
